module.exports = __webpack_public_path__ + "static/img/home_green-enegry.95eb85d4.jpg";